import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = "/web/referel-codes";

// Add a new device
function addCode(params: { reference_id: string; type: string; code: string }) {
  return api.create(`${baseUrl}`, params);
}

// Update device availability
function updateCode(params: { id: string; type: string; referel_code: string; is_active: boolean; is_valid: boolean }) {
  return api.updatePatch(`${baseUrl}/${params.id}`, params);
}

export { addCode, updateCode };
